import React from "react";
import { getCurrentUserStaticCB } from "../../auth/AuthService";
import ProfileChangePwd from "./profileChangePwd/ProfileChangePwd";

class UserProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { user: {} };
  }

  componentDidMount() {
    getCurrentUserStaticCB(user => {
      this.setState({ user });
    });
  }

  render() {
    const { user } = this.state;
    const firstLast =
      (user.contact && `${user.contact.firstname} ${user.contact.lastname}`) ||
      "Loading...";
    return (
      <div className="UserProfileView">
        <div className="grid-x">
          <div className="cell small-12">
            User:
            {firstLast}
          </div>
        </div>
        <br />
        <ProfileChangePwd />
      </div>
    );
  }
}

export default UserProfileView;
